import React from 'react';
import { Element } from './TravelTypeHeading.styles';
import { Text } from '@/components/typography';
import { usePacotesListContext } from '@/features/pacote/PacotesList/context';
import { TravelTypeIcon } from '@/features/pacote/PacotesList/components';

export interface HeadingTravelTypeProps {}

const TravelTypeHeading = ({ ...props }: HeadingTravelTypeProps) => {
  const {
    data: { travelType },
  } = usePacotesListContext();

  if (!travelType) {
    return null;
  }

  const { id, title, excerpt } = travelType;

  return (
    <Element>
      <Text weight="light" size="lg" color="neutral_500">
        <TravelTypeIcon id={id} width={32} color="neutral_500" /> {title}
      </Text>
      <Text size="sm">{excerpt}</Text>
    </Element>
  );
};

export default TravelTypeHeading;
